import React from "react";
import { useLocation } from "react-router-dom";

import ToolLayout from "../ToolLayout";
import CostEstimatorTool from "./CostEstimatorTool";
import CostEstimatorConfig from "./CostEstimator.config";

const CostEstimatorPage = () => {
  const location = useLocation();
  const state = location.state || {};
  const params = new URLSearchParams(location.search);

  const queryCategoryKey = params.get("category") || undefined;
  const queryZip = params.get("zip") || undefined;

  return (
    <ToolLayout
      title={CostEstimatorConfig.title}
      description={CostEstimatorConfig.description}
    >
      <CostEstimatorTool
        zip={state.zip || queryZip}
        initialProjectType={state.categoryKey || queryCategoryKey}
        precomputedEstimate={state.precomputedEstimate}
        customerId={state.customerId}
        surveyId={state.surveyId}
        categoryKey={state.categoryKey || queryCategoryKey}
      />
    </ToolLayout>
  );
};

export default CostEstimatorPage;
